<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row">
      <!--BOX_1-->
      <section class="col-12" id="section">
        <div class="card" [ngClass]="activeTab === 'box_1' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_1')">
            <h3>{{ "PARAGRAPH" | translate }} 1</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_1' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_1" [(ngModel)]="box_1"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_2 TASK-->
      <section class="col-12" id="section2">
        <div class="card" [ngClass]="activeTab === 'box_2_task' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_2_task')">
            <h3>{{ "PARAGRAPH" | translate }} 2 {{ "TASK" | translate }}</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_2_task' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_2_task" [(ngModel)]="box_2_task"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_2 TIME_MATERIAL-->
      <section class="col-12" id="section3">
        <div class="card" [ngClass]="activeTab === 'box_2_time_material' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_2_time_material')">
            <h3>{{ "PARAGRAPH" | translate }} 2 {{ "TIME_MATERIAL" | translate }}</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_2_time_material' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_2_time_material" [(ngModel)]="box_2_time_material"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section4">
        <div class="card" [ngClass]="activeTab === 'box_3' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_3')">
            <h3>{{ "PARAGRAPH" | translate }} 3</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_3' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_3" [(ngModel)]="box_3"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section5">
        <div class="card" [ngClass]="activeTab === 'box_4' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_4')">
            <h3>{{ "PARAGRAPH" | translate }} 4</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_4' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_4" [(ngModel)]="box_4"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section6">
        <div class="card" [ngClass]="activeTab === 'box_5' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_5')">
            <h3>{{ "PARAGRAPH" | translate }} 5</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_5' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_5" [(ngModel)]="box_5"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section7">
        <div class="card" [ngClass]="activeTab === 'box_6_task' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_6_task')">
            <h3>{{ "PARAGRAPH" | translate }} 6 {{ "TASK" | translate }}</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_6_task' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_6_task" [(ngModel)]="box_6_task"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section8">
        <div class="card" [ngClass]="activeTab === 'box_6_time_material' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_6_time_material')">
            <h3>{{ "PARAGRAPH" | translate }} 6 {{ "TIME_MATERIAL" | translate }}</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_6_time_material' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_6_time_material" [(ngModel)]="box_6_time_material"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section9">
        <div class="card" [ngClass]="activeTab === 'box_7' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_7')">
            <h3>{{ "PARAGRAPH" | translate }} 7</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_7' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_7" [(ngModel)]="box_7"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--BOX_1-->
      <section class="col-12" id="section10">
        <div class="card" [ngClass]="activeTab === 'box_8' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('box_8')">
            <h3>{{ "PARAGRAPH" | translate }} 8</h3>
            <h3></h3>
          </div>
          <div [ngClass]="activeTab === 'box_8' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" rows="5" id="box_8" [(ngModel)]="box_8"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-primary" (click)="edit()">{{ "EDIT" | translate }}</button>
      </div>
    </div>
  </div>
</div>
